var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "商户进件",
        visible: _vm.visible,
        width: 800,
        footer: null,
        maskClosable: false,
      },
      on: { cancel: _vm.handleClose },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _c(
            "a-row",
            { staticClass: "channel-cards", attrs: { gutter: 12 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-card",
                    {
                      attrs: {
                        size: "small",
                        title: "微信渠道",
                        bordered: true,
                      },
                    },
                    [
                      _c("a-tag", { attrs: { color: _vm.statusType } }, [
                        _vm._v(_vm._s(_vm.wxStatusText)),
                      ]),
                      _vm.statusInfo.jeepayMchNo &&
                      _vm.statusInfo.applyStatus === "3"
                        ? _c("div", { staticClass: "tip-text" }, [
                            _vm._v(
                              "\n            商户号：" +
                                _vm._s(_vm.statusInfo.jeepayMchNo) +
                                "\n          "
                            ),
                          ])
                        : !_vm.statusInfo.applyStatus
                        ? _c("div", { staticClass: "tip-text" }, [
                            _vm._v(
                              "未提交在线进件，可在下方进件向导中提交微信特约商户进件"
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-card",
                    {
                      attrs: {
                        size: "small",
                        title: "支付宝渠道",
                        bordered: true,
                      },
                    },
                    [
                      _vm.aliInfo.applyStatus === "1"
                        ? [
                            _vm.aliInfo.faceStatus === "3"
                              ? [
                                  _c("a-tag", { attrs: { color: "green" } }, [
                                    _vm._v("已开通"),
                                  ]),
                                  _c("div", { staticClass: "tip-text" }, [
                                    _vm._v(
                                      "商户号：" +
                                        _vm._s(_vm.aliInfo.jeepayMchNo)
                                    ),
                                  ]),
                                  _c("div", { staticClass: "tip-text" }, [
                                    _vm._v(
                                      "支付宝收款已开通（授权 + 当面付均已生效），付款码/扫码均可收款"
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "6px" } },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            loading: _vm.aliStarting,
                                          },
                                          on: { click: _vm.startAliAuth },
                                        },
                                        [_vm._v("重新授权")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm.aliInfo.faceStatus === "1"
                              ? [
                                  _c("a-tag", { attrs: { color: "blue" } }, [
                                    _vm._v("当面付审核中"),
                                  ]),
                                  _c("div", { staticClass: "tip-text" }, [
                                    _vm._v(
                                      "商户号：" +
                                        _vm._s(_vm.aliInfo.jeepayMchNo)
                                    ),
                                  ]),
                                  _c("div", { staticClass: "tip-text" }, [
                                    _vm._v(
                                      "支付宝审核一般数分钟至12小时，本页自动更新；超1个工作日未变化可联系支付宝客服 4007585858"
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "6px" } },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            loading: _vm.aliStarting,
                                          },
                                          on: { click: _vm.startAliAuth },
                                        },
                                        [_vm._v("重新授权")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm.aliInfo.faceStatus === "2"
                              ? [
                                  _c("a-tag", { attrs: { color: "orange" } }, [
                                    _vm._v("待商家确认"),
                                  ]),
                                  _vm.aliFaceQr
                                    ? _c("img", {
                                        staticClass: "sign-qr",
                                        attrs: {
                                          src:
                                            "data:image/png;base64," +
                                            _vm.aliFaceQr,
                                          alt: "当面付确认二维码",
                                        },
                                      })
                                    : _vm._e(),
                                  _c("div", { staticClass: "tip-text" }, [
                                    _vm._v("审核已通过，请商家用"),
                                    _c("strong", [_vm._v("支付宝App")]),
                                    _vm._v(
                                      '扫码确认开通"当面付"（也可在支付宝App-消息-消息盒子待办中确认）'
                                    ),
                                  ]),
                                  _c("div", { staticClass: "tip-text" }, [
                                    _vm._v("商家确认后本页自动更新为已开通"),
                                  ]),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "4px" } },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          attrs: { size: "small" },
                                          on: { click: _vm.openAliFaceConfirm },
                                        },
                                        [_vm._v("复制确认链接发给商家")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              : [
                                  _vm.aliInfo.faceStatus === "4"
                                    ? _c("a-tag", { attrs: { color: "red" } }, [
                                        _vm._v("签约驳回"),
                                      ])
                                    : _c("a-tag", [
                                        _vm._v("已授权·待开通当面付"),
                                      ]),
                                  _vm.aliInfo.faceStatus === "4"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "tip-text",
                                          staticStyle: { color: "#f5222d" },
                                        },
                                        [
                                          _vm._v(
                                            "驳回原因：" +
                                              _vm._s(
                                                _vm.aliInfo.faceRejectReason ||
                                                  "请联系平台客服"
                                              )
                                          ),
                                        ]
                                      )
                                    : _c("div", { staticClass: "tip-text" }, [
                                        _vm._v(
                                          '支付宝收款需开通"当面付"产品，资料已自动复用，仅补充经营类目即可提交'
                                        ),
                                      ]),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "6px" } },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: "请选择经营类目",
                                            "show-search": "",
                                            "filter-option":
                                              _vm.filterIndustryOption,
                                          },
                                          model: {
                                            value: _vm.faceForm.mccCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.faceForm,
                                                "mccCode",
                                                $$v
                                              )
                                            },
                                            expression: "faceForm.mccCode",
                                          },
                                        },
                                        _vm._l(_vm.aliMccOptions, function (g) {
                                          return _c(
                                            "a-select-opt-group",
                                            {
                                              key: g.label,
                                              attrs: { label: g.label },
                                            },
                                            _vm._l(g.options, function (opt) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: opt.value,
                                                  attrs: { value: opt.value },
                                                },
                                                [_vm._v(_vm._s(opt.label))]
                                              )
                                            }),
                                            1
                                          )
                                        }),
                                        1
                                      ),
                                      _c("a-cascader", {
                                        staticStyle: {
                                          "margin-top": "8px",
                                          width: "100%",
                                        },
                                        attrs: {
                                          options: _vm.bizAreaOptions,
                                          placeholder:
                                            "店铺所在省/市/区（选填）",
                                        },
                                        model: {
                                          value: _vm.faceForm.areaPath,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.faceForm,
                                              "areaPath",
                                              $$v
                                            )
                                          },
                                          expression: "faceForm.areaPath",
                                        },
                                      }),
                                      _c("a-input", {
                                        staticStyle: { "margin-top": "8px" },
                                        attrs: {
                                          placeholder:
                                            "店铺详细地址（选填，留空自动复用微信进件地址）",
                                          maxLength: "128",
                                        },
                                        model: {
                                          value: _vm.faceForm.detailAddress,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.faceForm,
                                              "detailAddress",
                                              $$v
                                            )
                                          },
                                          expression: "faceForm.detailAddress",
                                        },
                                      }),
                                      _c("a-input", {
                                        staticStyle: { "margin-top": "8px" },
                                        attrs: {
                                          placeholder:
                                            "商家支付宝账号（选填，留空自动获取）",
                                          maxLength: "64",
                                        },
                                        model: {
                                          value: _vm.faceForm.aliAccount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.faceForm,
                                              "aliAccount",
                                              $$v
                                            )
                                          },
                                          expression: "faceForm.aliAccount",
                                        },
                                      }),
                                      _c("a-input", {
                                        staticStyle: { "margin-top": "8px" },
                                        attrs: {
                                          placeholder:
                                            "执照法人手机号（授权支付宝与执照法人非同一人时必填，法人将收到短信授权）",
                                          maxLength: "11",
                                        },
                                        model: {
                                          value: _vm.faceForm.licenseMobile,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.faceForm,
                                              "licenseMobile",
                                              $$v
                                            )
                                          },
                                          expression: "faceForm.licenseMobile",
                                        },
                                      }),
                                      _c(
                                        "a-button",
                                        {
                                          staticStyle: { "margin-top": "8px" },
                                          attrs: {
                                            type: "primary",
                                            size: "small",
                                            loading: _vm.faceSubmitting,
                                          },
                                          on: { click: _vm.submitAliFaceSign },
                                        },
                                        [_vm._v("提交当面付签约")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                          ]
                        : _vm.aliInfo.applyStatus === "0"
                        ? [
                            _c("a-tag", { attrs: { color: "orange" } }, [
                              _vm._v("待授权"),
                            ]),
                            _vm.aliQr
                              ? _c("img", {
                                  staticClass: "sign-qr",
                                  attrs: {
                                    src: "data:image/png;base64," + _vm.aliQr,
                                    alt: "支付宝授权二维码",
                                  },
                                })
                              : _vm._e(),
                            _c("div", { staticClass: "tip-text" }, [
                              _vm._v("请用"),
                              _c("strong", [_vm._v("手机浏览器")]),
                              _vm._v(
                                '扫码（请勿用支付宝"扫一扫"），或点击按钮在本机浏览器打开授权页'
                              ),
                            ]),
                            _c("div", { staticClass: "tip-text" }, [
                              _vm._v("请用"),
                              _c("strong", [_vm._v("经营者本人的支付宝")]),
                              _vm._v(
                                "确认授权（授权谁的支付宝，收款就结算到谁的账户）；完成后本页自动更新"
                              ),
                            ]),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "4px" } },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: { click: _vm.openAliAuth },
                                  },
                                  [_vm._v("前往支付宝授权")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: {
                                      size: "small",
                                      loading: _vm.aliStarting,
                                    },
                                    on: { click: _vm.startAliAuth },
                                  },
                                  [_vm._v("重新发起授权")]
                                ),
                              ],
                              1
                            ),
                          ]
                        : [
                            _c("a-tag", [_vm._v("未开通")]),
                            _c("div", { staticClass: "tip-text" }, [
                              _vm._v(
                                "已有支付宝账号即可开通：扫码授权、无需资料、即时生效，收款直接结算到您的支付宝账户。"
                              ),
                            ]),
                            _c(
                              "a-button",
                              {
                                staticStyle: { "margin-top": "4px" },
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  loading: _vm.aliStarting,
                                },
                                on: { click: _vm.startAliAuth },
                              },
                              [_vm._v("扫码授权开通支付宝收款")]
                            ),
                          ],
                      _vm.aliEditing
                        ? _c(
                            "div",
                            { staticStyle: { "margin-top": "8px" } },
                            [
                              _c("a-input-search", {
                                attrs: {
                                  placeholder:
                                    "请输入平台运营提供的支付宝商户号",
                                  maxLength: 64,
                                  "enter-button": "保存",
                                  loading: _vm.aliSaving,
                                },
                                on: { search: _vm.saveAliMerchant },
                                model: {
                                  value: _vm.aliMchNo,
                                  callback: function ($$v) {
                                    _vm.aliMchNo = $$v
                                  },
                                  expression: "aliMchNo",
                                },
                              }),
                              _c("a-input", {
                                staticStyle: { "margin-top": "8px" },
                                attrs: {
                                  placeholder: "应用ID（平台运营提供，选填）",
                                  maxLength: 128,
                                },
                                model: {
                                  value: _vm.aliAppId,
                                  callback: function ($$v) {
                                    _vm.aliAppId = $$v
                                  },
                                  expression: "aliAppId",
                                },
                              }),
                              _c("a-input", {
                                staticStyle: { "margin-top": "8px" },
                                attrs: {
                                  placeholder: "应用密钥（平台运营提供，选填）",
                                  maxLength: 128,
                                },
                                model: {
                                  value: _vm.aliAppSecret,
                                  callback: function ($$v) {
                                    _vm.aliAppSecret = $$v
                                  },
                                  expression: "aliAppSecret",
                                },
                              }),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-top": "8px" },
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      _vm.aliEditing = false
                                    },
                                  },
                                },
                                [_vm._v("取消")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.statusInfo.applyStatus
            ? [
                _c(
                  "a-alert",
                  {
                    staticClass: "status-alert",
                    attrs: { type: _vm.statusType, "show-icon": "" },
                  },
                  [
                    _c(
                      "template",
                      { slot: "message" },
                      [
                        _c("span", [
                          _vm._v("当前状态：" + _vm._s(_vm.statusText)),
                        ]),
                        _vm.statusInfo.applyStatus === "1" ||
                        _vm.statusInfo.applyStatus === "2"
                          ? _c(
                              "a-button",
                              {
                                staticStyle: { "margin-left": "12px" },
                                attrs: { size: "small" },
                                on: { click: _vm.load },
                              },
                              [_vm._v("刷新进度")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("template", { slot: "description" }, [
                      _vm.statusInfo.applyStateMsg
                        ? _c("div", [
                            _vm._v(_vm._s(_vm.statusInfo.applyStateMsg)),
                          ])
                        : _vm._e(),
                      _vm.statusInfo.applyStatus === "1" &&
                      _vm.statusInfo.signUrl
                        ? _c("div", { staticStyle: { "margin-top": "8px" } }, [
                            _vm.signQr
                              ? _c("img", {
                                  staticClass: "sign-qr",
                                  attrs: {
                                    src: "data:image/png;base64," + _vm.signQr,
                                    alt: "账户验证二维码",
                                  },
                                })
                              : _vm._e(),
                            _c("div", { staticClass: "tip-text" }, [
                              _vm._v(
                                '请使用超级管理员微信扫码完成账户验证，完成后点击"刷新进度"。'
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.statusInfo.applyStatus === "2"
                        ? _c(
                            "div",
                            { staticStyle: { "margin-top": "8px" } },
                            [
                              _vm.signQr
                                ? _c("img", {
                                    staticClass: "sign-qr",
                                    attrs: {
                                      src:
                                        "data:image/png;base64," + _vm.signQr,
                                      alt: "签约二维码",
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "link",
                                    disabled: !_vm.statusInfo.signUrl,
                                  },
                                  on: { click: _vm.openSignUrl },
                                },
                                [_vm._v("打开签约/开户链接")]
                              ),
                              _c("div", { staticClass: "tip-text" }, [
                                _vm._v(
                                  '请使用超级管理员微信扫码完成签约（也可点击按钮打开链接），完成后点击"刷新进度"。'
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.statusInfo.applyStatus === "4" &&
                      _vm.statusInfo.auditRemark
                        ? _c("div", { staticClass: "reject-remark" }, [
                            _vm._v(
                              "\n            驳回原因：" +
                                _vm._s(_vm.statusInfo.auditRemark) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                      _vm.statusInfo.applyStatus === "3"
                        ? _c("div", { staticStyle: { "margin-top": "8px" } }, [
                            _c("div", [
                              _vm._v(
                                "Jeepay商户号：" +
                                  _vm._s(_vm.statusInfo.jeepayMchNo)
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                "微信特约商户号：" +
                                  _vm._s(_vm.statusInfo.subMchid)
                              ),
                            ]),
                            _c("div", { staticClass: "tip-text" }, [
                              _vm._v(
                                '收款商户号已自动回填到"支付商户"列表，本租户订单即可在线收款。'
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ],
                  2
                ),
                ["0", "1", "2", "3", "4"].indexOf(_vm.statusInfo.applyStatus) >
                -1
                  ? _c(
                      "a-collapse",
                      { staticStyle: { "margin-top": "8px" } },
                      [
                        _c(
                          "a-collapse-panel",
                          { key: "profile", attrs: { header: "查看进件资料" } },
                          _vm._l(_vm.profileRows, function (row) {
                            return _c(
                              "div",
                              { key: row.label, staticClass: "summary-row" },
                              [
                                _c("span", { staticClass: "summary-label" }, [
                                  _vm._v(_vm._s(row.label)),
                                ]),
                                _c("span", { staticClass: "summary-value" }, [
                                  _vm._v(_vm._s(row.value)),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.formEditable
            ? _c(
                "div",
                { staticStyle: { "margin-top": "8px" } },
                [
                  _vm.statusInfo.applyStatus
                    ? _c("a-divider", { attrs: { orientation: "left" } }, [
                        _vm._v("修改后重新提交"),
                      ])
                    : _vm._e(),
                  _c(
                    "a-steps",
                    {
                      staticClass: "wizard-steps",
                      attrs: { current: _vm.step - 1, size: "small" },
                      on: { change: _vm.onStepChange },
                    },
                    _vm._l(_vm.stepTitles, function (t) {
                      return _c("a-step", { key: t, attrs: { title: t } })
                    }),
                    1
                  ),
                  _c(
                    "a-form",
                    [
                      _vm.step === 1
                        ? [
                            _c("div", { staticClass: "tip-text ocr-tip" }, [
                              _vm._v(
                                "上传执照照片后自动识别商户名称、信用代码与法人，请核对识别结果"
                              ),
                            ]),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "执照照片" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c(
                                  "a-upload",
                                  {
                                    staticClass: "apply-uploader",
                                    attrs: {
                                      "list-type": "picture-card",
                                      accept: ".jpg,.jpeg,.bmp,.png",
                                      "file-list": _vm.fileList.licenseCopy,
                                      customRequest: (opt) =>
                                        _vm.doUpload(opt, "licenseCopy"),
                                      "before-upload": _vm.beforeUpload,
                                      remove: (f) =>
                                        _vm.handleRemove(f, "licenseCopy"),
                                    },
                                    on: { preview: _vm.handlePreview },
                                  },
                                  [
                                    !_vm.fileList.licenseCopy.length
                                      ? _c(
                                          "div",
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "plus" },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "ant-upload-text",
                                              },
                                              [_vm._v("上传")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "主体类型" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c(
                                  "a-select",
                                  {
                                    attrs: { placeholder: "请选择主体类型" },
                                    on: { change: _vm.handleSubjectChange },
                                    model: {
                                      value: _vm.form.subjectType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "subjectType", $$v)
                                      },
                                      expression: "form.subjectType",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "2500" } },
                                      [_vm._v("企业")]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "4" } },
                                      [_vm._v("个体工商户")]
                                    ),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "tip-text" }, [
                                  _vm._v(
                                    "已参加微信泛行业优惠费率活动，商户交易手续费按 0.38% 结算（未参加活动为 0.6%），提交后自动生效"
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "商户名称" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "营业执照上的商户全称",
                                    maxLength: 128,
                                  },
                                  model: {
                                    value: _vm.form.mchName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "mchName", $$v)
                                    },
                                    expression: "form.mchName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "注册号/统一社会信用代码" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "统一社会信用代码",
                                    maxLength: 32,
                                  },
                                  model: {
                                    value: _vm.form.licenseNumber,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "licenseNumber", $$v)
                                    },
                                    expression: "form.licenseNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "法定代表人" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "营业执照法定代表人姓名",
                                    maxLength: 64,
                                  },
                                  model: {
                                    value: _vm.form.licenseLegalPerson,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "licenseLegalPerson",
                                        $$v
                                      )
                                    },
                                    expression: "form.licenseLegalPerson",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm.step === 2
                        ? [
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "商户简称" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "收银台展示的简称",
                                    maxLength: 64,
                                  },
                                  model: {
                                    value: _vm.form.mchShortName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "mchShortName", $$v)
                                    },
                                    expression: "form.mchShortName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "联系人" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "已按执照法人自动填写",
                                    maxLength: 64,
                                  },
                                  model: {
                                    value: _vm.form.contactName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "contactName", $$v)
                                    },
                                    expression: "form.contactName",
                                  },
                                }),
                                _c("div", { staticClass: "tip-text" }, [
                                  _vm._v(
                                    "联系人仅用于平台内部联系；微信进件的超级管理员默认为经营者本人（按经营者身份证实名），联系手机用于接收微信验证短信"
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "联系手机" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "用于接收微信审核通知",
                                    maxLength: 20,
                                  },
                                  model: {
                                    value: _vm.form.contactMobile,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "contactMobile", $$v)
                                    },
                                    expression: "form.contactMobile",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "客服电话" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "客服电话",
                                    maxLength: 20,
                                  },
                                  model: {
                                    value: _vm.form.servicePhone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "servicePhone", $$v)
                                    },
                                    expression: "form.servicePhone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm.step === 3
                        ? [
                            _c("div", { staticClass: "tip-text ocr-tip" }, [
                              _vm._v(
                                "上传身份证照片后自动识别姓名、号码与有效期，请核对识别结果"
                              ),
                            ]),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "身份证人像面" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c(
                                  "a-upload",
                                  {
                                    staticClass: "apply-uploader",
                                    attrs: {
                                      "list-type": "picture-card",
                                      accept: ".jpg,.jpeg,.bmp,.png",
                                      "file-list": _vm.fileList.idCardCopy,
                                      customRequest: (opt) =>
                                        _vm.doUpload(opt, "idCardCopy"),
                                      "before-upload": _vm.beforeUpload,
                                      remove: (f) =>
                                        _vm.handleRemove(f, "idCardCopy"),
                                    },
                                    on: { preview: _vm.handlePreview },
                                  },
                                  [
                                    !_vm.fileList.idCardCopy.length
                                      ? _c(
                                          "div",
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "plus" },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "ant-upload-text",
                                              },
                                              [_vm._v("上传")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "身份证国徽面" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c(
                                  "a-upload",
                                  {
                                    staticClass: "apply-uploader",
                                    attrs: {
                                      "list-type": "picture-card",
                                      accept: ".jpg,.jpeg,.bmp,.png",
                                      "file-list": _vm.fileList.idCardNational,
                                      customRequest: (opt) =>
                                        _vm.doUpload(opt, "idCardNational"),
                                      "before-upload": _vm.beforeUpload,
                                      remove: (f) =>
                                        _vm.handleRemove(f, "idCardNational"),
                                    },
                                    on: { preview: _vm.handlePreview },
                                  },
                                  [
                                    !_vm.fileList.idCardNational.length
                                      ? _c(
                                          "div",
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "plus" },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "ant-upload-text",
                                              },
                                              [_vm._v("上传")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "身份证姓名" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "身份证姓名",
                                    maxLength: 64,
                                  },
                                  model: {
                                    value: _vm.form.idCardName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "idCardName", $$v)
                                    },
                                    expression: "form.idCardName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "身份证号码" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "身份证号码",
                                    maxLength: 18,
                                  },
                                  model: {
                                    value: _vm.form.idCardNumber,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "idCardNumber", $$v)
                                    },
                                    expression: "form.idCardNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "身份证有效期-起" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "如 2020-01-01",
                                    maxLength: 16,
                                  },
                                  model: {
                                    value: _vm.form.idCardPeriodBegin,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "idCardPeriodBegin",
                                        $$v
                                      )
                                    },
                                    expression: "form.idCardPeriodBegin",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "身份证有效期-止" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder:
                                      "如 2030-01-01；长期证件请填：长期",
                                    maxLength: 16,
                                  },
                                  model: {
                                    value: _vm.form.idCardPeriodEnd,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "idCardPeriodEnd", $$v)
                                    },
                                    expression: "form.idCardPeriodEnd",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm.form.subjectType === "2500"
                              ? [
                                  _c(
                                    "a-divider",
                                    { attrs: { orientation: "left" } },
                                    [_vm._v("受益所有人（企业必填）")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tip-text",
                                      staticStyle: { "margin-bottom": "8px" },
                                    },
                                    [
                                      _vm._v(
                                        '\n              持股≥25%的自然人均需填写；若法定代表人本人就是唯一持股人，点击"复用法人资料"一键填入即可\n            '
                                      ),
                                    ]
                                  ),
                                  _vm._l(_vm.form.uboList, function (ubo, idx) {
                                    return _c(
                                      "div",
                                      { key: idx, staticClass: "ubo-card" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "ubo-head" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "受益所有人 " + _vm._s(idx + 1)
                                              ),
                                            ]),
                                            _vm.form.uboList.length > 1
                                              ? _c(
                                                  "a-button",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      type: "danger",
                                                      icon: "delete",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removeUbo(
                                                          idx
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("删除")]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-form-item",
                                          _vm._b(
                                            { attrs: { label: "姓名" } },
                                            "a-form-item",
                                            _vm.formItemLayout,
                                            false
                                          ),
                                          [
                                            _c("a-input", {
                                              attrs: {
                                                placeholder:
                                                  "受益所有人身份证上的姓名",
                                                maxLength: 64,
                                              },
                                              model: {
                                                value: ubo.name,
                                                callback: function ($$v) {
                                                  _vm.$set(ubo, "name", $$v)
                                                },
                                                expression: "ubo.name",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-form-item",
                                          _vm._b(
                                            { attrs: { label: "身份证号" } },
                                            "a-form-item",
                                            _vm.formItemLayout,
                                            false
                                          ),
                                          [
                                            _c("a-input", {
                                              attrs: {
                                                placeholder: "18位身份证号码",
                                                maxLength: 18,
                                              },
                                              model: {
                                                value: ubo.idNumber,
                                                callback: function ($$v) {
                                                  _vm.$set(ubo, "idNumber", $$v)
                                                },
                                                expression: "ubo.idNumber",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-form-item",
                                          _vm._b(
                                            {
                                              attrs: { label: "身份证人像面" },
                                            },
                                            "a-form-item",
                                            _vm.formItemLayout,
                                            false
                                          ),
                                          [
                                            _c(
                                              "a-upload",
                                              {
                                                staticClass: "apply-uploader",
                                                attrs: {
                                                  "list-type": "picture-card",
                                                  accept:
                                                    ".jpg,.jpeg,.bmp,.png",
                                                  "file-list": ubo.flCopy,
                                                  customRequest: (opt) =>
                                                    _vm.doUploadUbo(
                                                      opt,
                                                      ubo,
                                                      "idCardCopy"
                                                    ),
                                                  "before-upload":
                                                    _vm.beforeUpload,
                                                  remove: () =>
                                                    _vm.handleRemoveUbo(
                                                      ubo,
                                                      "idCardCopy"
                                                    ),
                                                },
                                                on: {
                                                  preview: _vm.handlePreview,
                                                },
                                              },
                                              [
                                                !ubo.flCopy.length
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c("a-icon", {
                                                          attrs: {
                                                            type: "plus",
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ant-upload-text",
                                                          },
                                                          [_vm._v("上传")]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-form-item",
                                          _vm._b(
                                            {
                                              attrs: { label: "身份证国徽面" },
                                            },
                                            "a-form-item",
                                            _vm.formItemLayout,
                                            false
                                          ),
                                          [
                                            _c(
                                              "a-upload",
                                              {
                                                staticClass: "apply-uploader",
                                                attrs: {
                                                  "list-type": "picture-card",
                                                  accept:
                                                    ".jpg,.jpeg,.bmp,.png",
                                                  "file-list": ubo.flNational,
                                                  customRequest: (opt) =>
                                                    _vm.doUploadUbo(
                                                      opt,
                                                      ubo,
                                                      "idCardNational"
                                                    ),
                                                  "before-upload":
                                                    _vm.beforeUpload,
                                                  remove: () =>
                                                    _vm.handleRemoveUbo(
                                                      ubo,
                                                      "idCardNational"
                                                    ),
                                                },
                                                on: {
                                                  preview: _vm.handlePreview,
                                                },
                                              },
                                              [
                                                !ubo.flNational.length
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c("a-icon", {
                                                          attrs: {
                                                            type: "plus",
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ant-upload-text",
                                                          },
                                                          [_vm._v("上传")]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-form-item",
                                          _vm._b(
                                            {
                                              attrs: {
                                                label: "身份证有效期-起",
                                              },
                                            },
                                            "a-form-item",
                                            _vm.formItemLayout,
                                            false
                                          ),
                                          [
                                            _c("a-input", {
                                              attrs: {
                                                placeholder: "如 2020-01-01",
                                                maxLength: 16,
                                              },
                                              model: {
                                                value: ubo.periodBegin,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    ubo,
                                                    "periodBegin",
                                                    $$v
                                                  )
                                                },
                                                expression: "ubo.periodBegin",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-form-item",
                                          _vm._b(
                                            {
                                              attrs: {
                                                label: "身份证有效期-止",
                                              },
                                            },
                                            "a-form-item",
                                            _vm.formItemLayout,
                                            false
                                          ),
                                          [
                                            _c("a-input", {
                                              attrs: {
                                                placeholder:
                                                  "如 2030-01-01；长期证件请填：长期",
                                                maxLength: 16,
                                              },
                                              model: {
                                                value: ubo.periodEnd,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    ubo,
                                                    "periodEnd",
                                                    $$v
                                                  )
                                                },
                                                expression: "ubo.periodEnd",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-bottom": "8px" },
                                      attrs: {
                                        type: "dashed",
                                        block: "",
                                        icon: "plus",
                                      },
                                      on: { click: _vm.addUbo },
                                    },
                                    [_vm._v("添加受益所有人")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { icon: "copy" },
                                      on: { click: _vm.copyLegalAsUbo },
                                    },
                                    [_vm._v("复用法人资料（法人100%持股时）")]
                                  ),
                                ]
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm.step === 4
                        ? [
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "所属行业" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c(
                                  "a-select",
                                  {
                                    attrs: {
                                      placeholder: "请选择所属行业",
                                      "show-search": "",
                                      "filter-option": _vm.filterIndustryOption,
                                    },
                                    on: { change: _vm.onIndustryChange },
                                    model: {
                                      value: _vm.form.qualificationType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "qualificationType",
                                          $$v
                                        )
                                      },
                                      expression: "form.qualificationType",
                                    },
                                  },
                                  _vm._l(_vm.industryGroups, function (g) {
                                    return _c(
                                      "a-select-opt-group",
                                      {
                                        key: g.group,
                                        attrs: { label: g.group },
                                      },
                                      _vm._l(g.items, function (ind) {
                                        return _c(
                                          "a-select-option",
                                          {
                                            key: ind.name,
                                            attrs: { value: ind.name },
                                          },
                                          [_vm._v(_vm._s(ind.name))]
                                        )
                                      }),
                                      1
                                    )
                                  }),
                                  1
                                ),
                                _c("div", { staticClass: "tip-text" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.industryHint ||
                                        "请按营业执照经营范围选择最贴近的行业类目"
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "线下场所名称" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder:
                                      "门店招牌名称，与门头照上名称一致",
                                    maxLength: 128,
                                  },
                                  model: {
                                    value: _vm.form.bizStoreName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "bizStoreName", $$v)
                                    },
                                    expression: "form.bizStoreName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "线下场所省市区" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-cascader", {
                                  attrs: {
                                    value: _vm.bizAreaPath,
                                    options: _vm.bizAreaOptions,
                                    placeholder: "请选择营业执照所在省/市/区",
                                  },
                                  on: { change: _vm.onBizAreaChange },
                                }),
                                _c("div", { staticClass: "tip-text" }, [
                                  _vm._v("请选择营业执照对应的省市区"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "线下场所地址" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder:
                                      "营业执照地址去掉省市区后的部分",
                                    maxLength: 512,
                                  },
                                  model: {
                                    value: _vm.form.bizStoreAddress,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "bizStoreAddress", $$v)
                                    },
                                    expression: "form.bizStoreAddress",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "门头照片" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c(
                                  "a-upload",
                                  {
                                    staticClass: "apply-uploader",
                                    attrs: {
                                      "list-type": "picture-card",
                                      accept: ".jpg,.jpeg,.bmp,.png",
                                      multiple: "",
                                      "file-list":
                                        _vm.fileList.storeEntrancePic,
                                      customRequest: (opt) =>
                                        _vm.doUploadMulti(
                                          opt,
                                          "storeEntrancePic"
                                        ),
                                      "before-upload": _vm.beforeUpload,
                                      remove: (f) =>
                                        _vm.removeMulti(f, "storeEntrancePic"),
                                    },
                                    on: { preview: _vm.handlePreview },
                                  },
                                  [
                                    _vm.fileList.storeEntrancePic.length < 5
                                      ? _c(
                                          "div",
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "plus" },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "ant-upload-text",
                                              },
                                              [_vm._v("上传")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c("div", { staticClass: "tip-text" }, [
                                  _vm._v(
                                    "正面拍摄、清晰完整、图片不得有遮挡；门店招牌清晰、名称文字可辨识、门框完整且店面显示在营（1-5张）"
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "内部照片" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c(
                                  "a-upload",
                                  {
                                    staticClass: "apply-uploader",
                                    attrs: {
                                      "list-type": "picture-card",
                                      accept: ".jpg,.jpeg,.bmp,.png",
                                      multiple: "",
                                      "file-list": _vm.fileList.indoorPic,
                                      customRequest: (opt) =>
                                        _vm.doUploadMulti(opt, "indoorPic"),
                                      "before-upload": _vm.beforeUpload,
                                      remove: (f) =>
                                        _vm.removeMulti(f, "indoorPic"),
                                    },
                                    on: { preview: _vm.handlePreview },
                                  },
                                  [
                                    _vm.fileList.indoorPic.length < 5
                                      ? _c(
                                          "div",
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "plus" },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "ant-upload-text",
                                              },
                                              [_vm._v("上传")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c("div", { staticClass: "tip-text" }, [
                                  _vm._v(
                                    "能展示内部环境并辨识所经营的业务/销售商品（1-5张）；停车场等开阔场地可上传内部环境照片"
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm.industryNeedPics
                              ? [
                                  _c(
                                    "a-divider",
                                    { attrs: { orientation: "left" } },
                                    [_vm._v("行业资质（必填）")]
                                  ),
                                  _c(
                                    "a-form-item",
                                    _vm._b(
                                      { attrs: { label: "资质照片" } },
                                      "a-form-item",
                                      _vm.formItemLayout,
                                      false
                                    ),
                                    [
                                      _c(
                                        "a-upload",
                                        {
                                          staticClass: "apply-uploader",
                                          attrs: {
                                            "list-type": "picture-card",
                                            accept: ".jpg,.jpeg,.bmp,.png",
                                            multiple: "",
                                            "file-list":
                                              _vm.fileList.qualificationPics,
                                            customRequest: (opt) =>
                                              _vm.doUploadMulti(
                                                opt,
                                                "qualificationPics"
                                              ),
                                            "before-upload": _vm.beforeUpload,
                                            remove: (f) =>
                                              _vm.removeMulti(
                                                f,
                                                "qualificationPics"
                                              ),
                                          },
                                          on: { preview: _vm.handlePreview },
                                        },
                                        [
                                          _vm.fileList.qualificationPics
                                            .length < 5
                                            ? _c(
                                                "div",
                                                [
                                                  _c("a-icon", {
                                                    attrs: { type: "plus" },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ant-upload-text",
                                                    },
                                                    [_vm._v("上传")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c("div", { staticClass: "tip-text" }, [
                                        _vm._v(_vm._s(_vm.industryHint)),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm.step === 5
                        ? [
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "账户类型" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c(
                                  "a-select",
                                  {
                                    attrs: {
                                      placeholder: "请选择账户类型",
                                      disabled: _vm.form.subjectType === "2500",
                                    },
                                    on: { change: _vm.onAccountTypeChange },
                                    model: {
                                      value: _vm.form.bankAccountType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "bankAccountType",
                                          $$v
                                        )
                                      },
                                      expression: "form.bankAccountType",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "CORPORATE" } },
                                      [_vm._v("对公账户")]
                                    ),
                                    _c(
                                      "a-select-option",
                                      {
                                        attrs: {
                                          value: "PERSONAL",
                                          disabled:
                                            _vm.form.subjectType === "2500",
                                        },
                                      },
                                      [_vm._v("经营者个人银行卡")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm.form.subjectType === "2500"
                                  ? _c("div", { staticClass: "tip-text" }, [
                                      _vm._v("企业主体必须使用对公账户"),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "开户名称" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder:
                                      "对公账户为商户名称，个人卡为经营者姓名",
                                    maxLength: 128,
                                  },
                                  model: {
                                    value: _vm.form.accountName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "accountName", $$v)
                                    },
                                    expression: "form.accountName",
                                  },
                                }),
                                _c("div", { staticClass: "tip-text" }, [
                                  _vm._v(
                                    "已按账户类型自动预填：对公填商户名称，个人卡填经营者身份证姓名"
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "开户银行" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c(
                                  "a-select",
                                  {
                                    attrs: {
                                      placeholder:
                                        "请选择开户银行（微信官方银行列表）",
                                      "show-search": "",
                                      "filter-option": _vm.filterBankOption,
                                    },
                                    on: { change: _vm.onBankChange },
                                    model: {
                                      value: _vm.form.accountBank,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "accountBank", $$v)
                                      },
                                      expression: "form.accountBank",
                                    },
                                  },
                                  _vm._l(_vm.wxBankOptions, function (b) {
                                    return _c(
                                      "a-select-option",
                                      { key: b, attrs: { value: b } },
                                      [_vm._v(_vm._s(b))]
                                    )
                                  }),
                                  1
                                ),
                                _c("div", { staticClass: "tip-text" }, [
                                  _vm._v(
                                    "微信官方银行列表；选择列表内银行无需填写支行信息"
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm.isDirectBank
                              ? _c(
                                  "a-form-item",
                                  _vm._b(
                                    { attrs: { label: "开户行全称" } },
                                    "a-form-item",
                                    _vm.formItemLayout,
                                    false
                                  ),
                                  [
                                    _c("a-input", {
                                      attrs: {
                                        value: _vm.form.accountBank,
                                        disabled: "",
                                      },
                                    }),
                                    _c("div", { staticClass: "tip-text" }, [
                                      _vm._v(
                                        _vm._s(_vm.form.accountBank) +
                                          "为微信直连银行，无需填写支行，自动以总行名称提交"
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _c(
                                  "a-form-item",
                                  _vm._b(
                                    { attrs: { label: "开户行全称" } },
                                    "a-form-item",
                                    _vm.formItemLayout,
                                    false
                                  ),
                                  [
                                    _c("a-select", {
                                      attrs: {
                                        "show-search": "",
                                        "allow-clear": "",
                                        placeholder:
                                          "输入支行名称模糊搜索，如：大丰 / 海淀支行",
                                        "filter-option": false,
                                        "default-active-first-option": false,
                                        loading: _vm.branchSearching,
                                        options: _vm.branchOptions,
                                      },
                                      on: {
                                        search: _vm.onBranchSearch,
                                        change: _vm.onBranchSelect,
                                      },
                                      model: {
                                        value: _vm.form.bankName,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "bankName", $$v)
                                        },
                                        expression: "form.bankName",
                                      },
                                    }),
                                    _c("div", { staticClass: "tip-text" }, [
                                      _vm._v(
                                        '请先从上方选择"其他银行"，再从联行号库搜索支行并选择，自动填写省市编码'
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "开户银行所在地" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-cascader", {
                                  attrs: {
                                    value: _vm.bankAreaPath,
                                    options: _vm.areaOptions,
                                    placeholder: "请选择开户银行所在省/市",
                                  },
                                  on: { change: _vm.onAreaChange },
                                }),
                                _c("div", { staticClass: "tip-text" }, [
                                  _vm._v(
                                    "选择后自动填写微信省市编码；从支行列表选择支行时也会自动带出"
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "银行账号" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "银行账号",
                                    maxLength: 32,
                                  },
                                  model: {
                                    value: _vm.form.accountNumber,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "accountNumber", $$v)
                                    },
                                    expression: "form.accountNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                { attrs: { label: "银行卡识别" } },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c(
                                  "a-upload",
                                  {
                                    attrs: {
                                      "show-upload-list": false,
                                      accept: ".jpg,.jpeg,.png",
                                      customRequest: _vm.onBankCardOcr,
                                      "before-upload": _vm.beforeUpload,
                                    },
                                  },
                                  [
                                    _c(
                                      "a-button",
                                      { attrs: { icon: "camera" } },
                                      [_vm._v("上传银行卡照片自动识别")]
                                    ),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "tip-text" }, [
                                  _vm._v(
                                    "自动识别银行账号与开户银行，识别结果可手动修正"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm.step === 6
                        ? [
                            _c(
                              "div",
                              { staticClass: "summary-box" },
                              [
                                _vm._l(_vm.summaryRows, function (row) {
                                  return _c(
                                    "div",
                                    {
                                      key: row.label,
                                      staticClass: "summary-row",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "summary-label" },
                                        [_vm._v(_vm._s(row.label))]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "summary-value" },
                                        [_vm._v(_vm._s(row.value))]
                                      ),
                                    ]
                                  )
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "tip-text",
                                    staticStyle: { "margin-top": "8px" },
                                  },
                                  [
                                    _vm._v(
                                      "请核对以上信息并选择要开通的收款渠道，确认无误后提交"
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                            _c(
                              "a-form-item",
                              _vm._b(
                                {
                                  staticStyle: { "margin-top": "8px" },
                                  attrs: { label: "开通渠道" },
                                },
                                "a-form-item",
                                _vm.formItemLayout,
                                false
                              ),
                              [
                                _c(
                                  "a-checkbox-group",
                                  {
                                    model: {
                                      value: _vm.channels,
                                      callback: function ($$v) {
                                        _vm.channels = $$v
                                      },
                                      expression: "channels",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-checkbox",
                                      { attrs: { value: "WX" } },
                                      [
                                        _vm._v(
                                          "微信支付（提交资料审核，1-2天）"
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "a-checkbox",
                                      { attrs: { value: "ALI" } },
                                      [
                                        _vm._v(
                                          "支付宝（扫码授权，无需资料，即时生效）"
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "margin-top": "8px",
                      },
                    },
                    [
                      _c("a-button", { on: { click: _vm.handleClose } }, [
                        _vm._v("关闭"),
                      ]),
                      _vm.step > 1
                        ? _c(
                            "a-button",
                            {
                              staticStyle: { "margin-left": "8px" },
                              on: { click: _vm.prevStep },
                            },
                            [_vm._v("上一步")]
                          )
                        : _vm._e(),
                      _vm.step < 6
                        ? _c(
                            "a-button",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { type: "primary" },
                              on: { click: _vm.nextStep },
                            },
                            [_vm._v("下一步")]
                          )
                        : _c(
                            "a-button",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: {
                                type: "primary",
                                loading: _vm.submitting,
                              },
                              on: { click: _vm.handleSubmit },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.submitBtnText) +
                                  "\n        "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.previewVisible,
            footer: null,
            width: 720,
            zIndex: 1200,
            title: "证件照片",
          },
          on: {
            cancel: function ($event) {
              _vm.previewVisible = false
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.previewImage, alt: "证件照片" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }